export default "__VITE_ASSET__20cab2b5__"